import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Image } from 'expo-image';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import ExploreCardOverlay from './ExploreCardOverlay';
import { exploreMediaZoomStyles as mz } from './exploreCardMediaZoomStyles';

const ExploreCard3D = React.memo(({ item, style, hovered }) => {
  const hasThumbnail = !!item.thumbnailPath;
  const format = item.metadata?.format
    || item.metadata?.['3d']?.format
    || (item.cdnPath ? item.cdnPath.split('?')[0].split('.').pop()?.toLowerCase() : null);
  const formatLabel = format ? format.toUpperCase() : '3D';

  return (
    <>
      <View style={mz.clip}>
        <View style={[mz.zoom, hovered && mz.zoomHovered]}>
          {hasThumbnail ? (
            <Image
              source={{ uri: item.thumbnailPath }}
              style={[styles.cover, style]}
              pointerEvents="none"
              contentFit="cover"
              placeholder={item.blurhash ? { blurhash: item.blurhash } : undefined}
              transition={200}
              recyclingKey={item.id}
              priority="low"
            />
          ) : (
            <View style={[styles.cover, styles.placeholder, style]}>
              <Icon name="cube" size={48} color="rgba(255,255,255,0.6)" solid />
            </View>
          )}
        </View>
      </View>

      <View style={styles.centerContent} pointerEvents="none">
        <View style={styles.formatPill}>
          <Icon name="cube" size={11} color="#fff" solid />
          <Text size="xxs" weight="semiBold" color="white">{formatLabel}</Text>
        </View>
      </View>

      <ExploreCardOverlay
        prompt={item.displayName || item.prompt}
        modelName={item.modelName}
        modelSlug={item.modelSlug}
        mediaType="3d"
        isPlusShowcase={item.flags?.isPlusShowcase}
        hovered={hovered}
        variationCount={item.variationCount}
      />
    </>
  );
});

ExploreCard3D.displayName = 'ExploreCard3D';

const styles = StyleSheet.create({
  cover: {
    ...StyleSheet.absoluteFillObject,
  },
  placeholder: {
    backgroundColor: 'rgba(20, 24, 28, 0.85)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  centerContent: {
    position: 'absolute',
    top: 8,
    left: 8,
  },
  formatPill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    backgroundColor: 'rgba(0,0,0,0.55)',
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 4,
  },
});

export default ExploreCard3D;
